import React, { useState, useMemo } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css"; 

function ProductAvailability() {
  const [products] = useState([
    {
      id: 1,
      name: "Wireless Headphones",
      sku: "WH-2025",
      category: "Electronics",
      price: 150,
      stock: 50,
      availableFrom: "2025-09-01",
      status: "Active",
      createdAt: "2025-08-15",
      image: "https://m.media-amazon.com/images/I/61pIzNaNRWL._UF1000,1000_QL80_.jpg",
    },
    {
      id: 2,
      name: "Smart Watch",
      sku: "SW-1025",
      category: "Electronics",
      price: 120,
      stock: 25,
      availableFrom: "2025-09-10",
      status: "Active",
      createdAt: "2025-08-20",
      image: "https://m.media-amazon.com/images/I/61pIzNaNRWL._UF1000,1000_QL80_.jpg",
    },
    {
      id: 3,
      name: "Running Shoes",
      sku: "RS-3030",
      category: "Footwear",
      price: 80,
      stock: 0,
      availableFrom: "2025-09-05",
      status: "Inactive",
      createdAt: "2025-08-22",
      image: "https://m.media-amazon.com/images/I/61pIzNaNRWL._UF1000,1000_QL80_.jpg",
    },
  ]);

  const [filters, setFilters] = useState({
    search: "",
    category: "All",
    status: "All",
    stock: "All",
    priceMin: "",
    priceMax: "",
    dateFrom: null,
    dateTo: null,
  });

  const [showFilter, setShowFilter] = useState(false);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateChange = (name, date) => {
    setFilters({ ...filters, [name]: date[0] });
  };

  const filteredProducts = useMemo(() => {
    return products.filter((p) => {
      const matchesSearch =
        p.name.toLowerCase().includes(filters.search.toLowerCase()) ||
        p.sku.toLowerCase().includes(filters.search.toLowerCase());

      const matchesCategory =
        filters.category === "All" || p.category === filters.category;

      const matchesStatus =
        filters.status === "All" || p.status === filters.status;

      const matchesStock =
        filters.stock === "All" ||
        (filters.stock === "InStock" && p.stock > 0) ||
        (filters.stock === "OutOfStock" && p.stock === 0);

      const matchesPrice =
        (filters.priceMin === "" || p.price >= Number(filters.priceMin)) &&
        (filters.priceMax === "" || p.price <= Number(filters.priceMax));

      const matchesDate =
        (!filters.dateFrom || new Date(p.availableFrom) >= filters.dateFrom) &&
        (!filters.dateTo || new Date(p.availableFrom) <= filters.dateTo);

      return (
        matchesSearch &&
        matchesCategory &&
        matchesStatus &&
        matchesStock &&
        matchesPrice &&
        matchesDate
      );
    });
  }, [products, filters]);

  const categories = ["All", ...new Set(products.map((p) => p.category))];

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="breadcrumb-title">Product Inventory</h4>
            <button
              className="btn btn-primary"
              onClick={() => setShowFilter(true)}
            >
              Filters
            </button>
          </div>

          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-body table-responsive">
                <table className="table table-hover table-striped align-middle">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Image</th>
                      <th>Product Name</th>
                      <th>SKU</th>
                      <th>Category</th>
                      <th>Price ($)</th>
                      <th>Stock</th>
                      <th>Available From</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredProducts.map((p) => (
                      <tr key={p.id}>
                        <td>{p.id}</td>
                        <td>
                          <img
                            src={p.image}
                            alt={p.name}
                            className="rounded"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                            }}
                          />
                        </td>
                        <td>{p.name}</td>
                        <td>{p.sku}</td>
                        <td>{p.category}</td>
                        <td>${p.price}</td>
                        <td>
                          {p.stock > 0 ? (
                            <span className="badge bg-success">
                              {p.stock} in stock
                            </span>
                          ) : (
                            <span className="badge bg-danger">Out of stock</span>
                          )}
                        </td>
                        <td>{p.availableFrom}</td>
                        <td>
                          <span
                            className={`badge ${
                              p.status === "Active" ? "bg-success" : "bg-secondary"
                            }`}
                          >
                            {p.status}
                          </span>
                        </td>
                        <td>{p.createdAt}</td>
                        <td>
                          <div className="d-flex gap-1">
                            <button className="btn btn-sm btn-primary">Edit</button>
                            <button className="btn btn-sm btn-danger">Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Custom Filter Panel */}
          <div className={`filter-panel ${showFilter ? "open" : ""}`}>
            <div className="filter-header">
              <h5>Filters</h5>
              <button
                className="btn-close"
                onClick={() => setShowFilter(false)}
              ></button>
            </div>
            <div className="filter-body">
              <div className="mb-3">
                <label>Search</label>
                <input
                  type="text"
                  className="form-control"
                  name="search"
                  placeholder="Product name or SKU"
                  value={filters.search}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="mb-3">
                <label>Category</label>
                <select
                  className="form-control"
                  name="category"
                  value={filters.category}
                  onChange={handleFilterChange}
                >
                  {categories.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Status</label>
                <select
                  className="form-control"
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="All">All</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
              <div className="mb-3">
                <label>Stock</label>
                <select
                  className="form-control"
                  name="stock"
                  value={filters.stock}
                  onChange={handleFilterChange}
                >
                  <option value="All">All</option>
                  <option value="InStock">In Stock</option>
                  <option value="OutOfStock">Out of Stock</option>
                </select>
              </div>
              <div className="mb-3">
                <label>Price Min</label>
                <input
                  type="number"
                  className="form-control"
                  name="priceMin"
                  value={filters.priceMin}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="mb-3">
                <label>Price Max</label>
                <input
                  type="number"
                  className="form-control"
                  name="priceMax"
                  value={filters.priceMax}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="mb-3">
                <label>Available From</label>
                <Flatpickr
                  value={filters.dateFrom}
                  onChange={(date) => handleDateChange("dateFrom", date)}
                  options={{ dateFormat: "Y-m-d" }}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label>Available To</label>
                <Flatpickr
                  value={filters.dateTo}
                  onChange={(date) => handleDateChange("dateTo", date)}
                  options={{ dateFormat: "Y-m-d" }}
                  className="form-control"
                />
              </div>
              <button
                className="btn btn-primary w-100"
                onClick={() => setShowFilter(false)}
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default ProductAvailability;
